import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDOfXDuvDFAaE-YQt5rgFg_7C2r_QjEsB8",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "gradlinv-v2.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "gradlinv-v2",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "gradlinv-v2.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "532383985793",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:532383985793:web:cf721d670216621076dd80",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
googleProvider.addScope('email');
googleProvider.addScope('profile');

export default app;
